import { ScreenLoading } from '@ui-components/neo.tax';

import { NavigateTo } from '../navigate';

export type RedirectState = {
  redirectTo?: string;
  isLoading: boolean;
};

export const Loader = ({
  children,
  useRedirect = (): RedirectState => ({ isLoading: false }),
}: {
  children: React.ReactNode;
  useRedirect: () => RedirectState;
}): React.ReactElement => {
  const { isLoading, redirectTo } = useRedirect();

  if (isLoading) {
    return <ScreenLoading />;
  }
  if (redirectTo) {
    return <NavigateTo to={redirectTo} />;
  }
  return <>{children}</>;
};
